import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Accesso effettuato");
      nav("/admin", { replace: true });
    } else {
      toast.error(res.error || "Accesso non riuscito");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="admin-login-page">
      <header className="px-6 lg:px-10 py-6">
        <Logo />
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="text-xs uppercase tracking-editorial text-muted-ink mb-3">Area riservata</div>
          <h1 className="font-display text-4xl text-brand mb-2">{t("admin.login_title")}</h1>
          <p className="text-muted-ink text-sm mb-8">{t("admin.login_sub")}</p>
          <form onSubmit={submit} className="space-y-4">
            <Input
              type="email"
              required
              placeholder={t("admin.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none border-soft bg-white"
              data-testid="admin-login-email"
            />
            <Input
              type="password"
              required
              placeholder={t("admin.password")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none border-soft bg-white"
              data-testid="admin-login-password"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full rounded-full bg-brand text-white py-3 text-sm hover:bg-[#0f2020] disabled:opacity-50 transition-colors"
            >
              {loading ? "…" : t("admin.login_btn")}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
